var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCombined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1074 0C14.6596 0 15.1074 0.447715 15.1074 1L15.107 3.532L15.6082 2.81915C15.9006 2.40155 16.4544 2.27574 16.8937 2.50801L17.0009 2.57358L21.0967 5.44146C21.5143 5.73387 21.6401 6.28767 21.4078 6.72696L21.3423 6.83419L16.1801 14.2066C15.8877 14.6242 15.3339 14.75 14.8946 14.5177L14.7874 14.4521L11.284 12H10.734L7.23585 14.4521C6.78345 14.7689 6.1599 14.659 5.84312 14.2066L0.680934 6.83419C0.364156 6.38178 0.474104 5.75824 0.926509 5.44146L5.02227 2.57358C5.47467 2.2568 6.09822 2.36675 6.415 2.81915L7.107 3.80864V5.55264L5.59585 3.39273L1.50009 6.26061L6.66227 13.633L8.991 12H8.10736C7.55507 12 7.10736 11.5523 7.10736 11V1C7.10736 0.447715 7.55507 0 8.10736 0H14.1074ZM16.4274 3.39273L15.107 5.276L15.1074 11C15.1074 11.5523 14.6596 12 14.1074 12H13.03L15.3609 13.633L20.5231 6.26061L16.4274 3.39273ZM14.1074 1H8.10736V11H14.1074V1Z",
    fill: "var(--color-text-primary)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombined);
export default __webpack_public_path__ + "static/media/combined.4e26c8d5527505edfab118a5b58e2933.svg";
export { ForwardRef as ReactComponent };